import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import BACKEND_URL from '../config'; // Adjust path as needed

const Warranty = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = location.state?.token;

  useEffect(() => {
    if (!token) {
      alert('⚠️ Session expired. Please log in again.');
      navigate('/admin');
    }
  }, [token, navigate]);

  const [form, setForm] = useState({
    category: '',
    name: '', phone: '', email: '', address: '', country: '',
    rollCode: '',
    make: '', model: '', year: '', vin: '', areasProtected: '',
    authorisedInstaller: '', installationLocation: '', installationDate: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === 'rollCode'
        ? value.toUpperCase().replace(/[^A-Z0-9]/g, '')
        : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${BACKEND_URL}/api/warranty`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('✅ Vehicle saved and email sent!');
      window.location.reload();
    } catch (err) {
      const status = err.response?.status;
      if (status === 401) {
        alert('❌ Session expired. Please log in again.');
        navigate('/admin');
      } else if (status === 409) {
        alert(`⚠️ ${err.response.data.error}`);
      } else {
        alert('❌ Error saving vehicle. Try again.');
      }
    }
  };

  return (
    <div className="container my-5">
      <h2 className="text-warning text-center mb-4">
        Admin – Add Vehicle Warranty
      </h2>

      <form onSubmit={handleSubmit} className="border p-4 rounded shadow-sm bg-light">
        {/* Category */}
        <h5 className="mb-3">Category</h5>
        <select
          name="category"
          value={form.category}
          onChange={handleChange}
          className="form-select mb-4"
          required
        >
          <option value="">-- Select Category --</option>
          <option>Ultra</option>
          <option>Ultimate</option>
          <option>Platinum</option>
          <option>Matte</option>
          <option>Gloss Black</option>
        </select>

        {/* Contact Info */}
        <h5 className="mb-3">Contact Information</h5>
        <div className="row">
          {['name', 'phone', 'email', 'country'].map((field) => (
            <div key={field} className="col-md-6 mb-3">
              <label className="form-label">
                {field.charAt(0).toUpperCase() + field.slice(1)}
              </label>
              <input
                name={field}
                value={form[field]}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
          ))}
          <div className="col-12 mb-3">
            <label className="form-label">Address</label>
            <input
              name="address"
              value={form.address}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
        </div>

        {/* Roll Code */}
        <hr />
        <h5 className="mb-3">Roll Code</h5>
        <input
          name="rollCode"
          value={form.rollCode}
          onChange={handleChange}
          className="form-control mb-4"
          placeholder="A–Z & 0–9 only"
          required
        />

        {/* Vehicle Info */}
        <hr />
        <h5 className="mb-3">Vehicle Information</h5>
        <div className="row">
          {[
            'make',
            'model',
            'year',
            'vin',
            'areasProtected',
            'authorisedInstaller',
            'installationLocation',
          ].map((field) => {
            const label = field.replace(/([A-Z])/g, ' $1').replace(/\b\w/g, c => c.toUpperCase());
            return (
              <div key={field} className="col-md-6 mb-3">
                <label className="form-label">{label}</label>
                <input
                  name={field}
                  value={form[field]}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
            );
          })}
          <div className="col-md-6 mb-3">
            <label className="form-label">Installation Date</label>
            <input
              type="date"
              name="installationDate"
              value={form.installationDate}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
        </div>

        <button className="btn btn-warning w-100">Save & Send Email</button>
      </form>
    </div>
  );
};

export default Warranty;
